import { render } from "./TypeAdd.vue?vue&type=template&id=76452e48"
import script from "./TypeAdd.vue?vue&type=script&lang=js"
export * from "./TypeAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__